var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSegment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.31539 -1.842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30.463 30.767-14.147-24.758-14.147 24.758h14.147z",
    fill: "#7f7f7f",
    stroke: "#333",
    strokeWidth: 2.1506
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.31539 -3.8423)",
    display: "none",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.228 28.851-10.912-19.096-10.912 19.096h10.912z",
    display: "inline",
    stroke: "#0076ff",
    strokeWidth: 1.6588
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.463 30.767-14.147-24.758-14.147 24.758h14.147z",
    stroke: "#333",
    strokeWidth: 2.1506
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegment);
export default __webpack_public_path__ + "static/media/segment.9a04d23259c34274bf744df2382ea6d0.svg";
export { ForwardRef as ReactComponent };